(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["manifest-welcome-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const popup = document.getElementById('manifest-welcome-popup');
  if (!popup || window.Shopify?.designMode) return;
  const key = 'manifest-welcome-dismissed';
  const subscribed = popup.querySelector('[data-manifest-subscribed]');
  const hasErrors = popup.querySelector('[role="alert"]');
  let dismissed = false;
  try { dismissed = sessionStorage.getItem(key) === '1'; } catch {}
  if (dismissed && !hasErrors && !subscribed) return;
  const priorFocus = document.activeElement;
  const priorOverflow = document.documentElement.style.overflow;
  const close = () => popup.close();
  popup.querySelector('.manifest-popup-close').addEventListener('click', close);
  popup.addEventListener('click', event => {
    const rect = popup.getBoundingClientRect();
    if (event.target === popup && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
  });
  popup.addEventListener('close', () => {
    document.documentElement.style.overflow = priorOverflow;
    try { sessionStorage.setItem(key, '1'); } catch {}
    if (priorFocus instanceof HTMLElement) priorFocus.focus({ preventScroll: true });
  });
  popup.showModal();
  document.documentElement.style.overflow = 'hidden';
})();
  } catch(e) { console.error(e); }
})();

})();
